import { render, staticRenderFns } from "./PreviewEventManager.vue?vue&type=template&id=19c1f45f&scoped=true&"
import script from "./PreviewEventManager.vue?vue&type=script&lang=js&"
export * from "./PreviewEventManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c1f45f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
